module.exports = __webpack_public_path__ + "static/media/error.a1bef827.gif";